import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonLinkComponent } from '@mode/capra';
import { DateTime } from '@mode-switch/express';

import { MetaTags, MetaTagsService, LocalStorageService } from '@mode/shared/util-js';
import { AnalyticsEvent, AnalyticsService } from '@mode/shared/util-segment';

@Component({
  selector: 'mode-google-auth-link',
  standalone: true,
  imports: [CommonModule, ButtonLinkComponent],
  templateUrl: './google-auth-link.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GoogleAuthLinkComponent {
  @Input() googleAuthUri?: string;
  constructor(
    private analyticsService: AnalyticsService,
    private meta: MetaTagsService,
    private localStorageService: LocalStorageService
  ) {}
  sendgGoolgeAuthAnalyticsEvent() {
    const eventData = {
      action: AnalyticsEvent.SubContext.GoogleAuthSetup,
      session_ID: this.localStorageService.getItem('LAST_ACTIVE_TAB_ID'),
      user_ID: this.meta.getTag(MetaTags.CurrentUsername),
      timestamp: DateTime,
    };
    this.analyticsService.track(AnalyticsEvent.Name.GoogleAuthSetup, eventData);
  }
}
